module.exports = __webpack_public_path__ + "img/m.0b45fd03.webp";